import util from '@/util/util'
/**
 * @description 请求接口列表
 * @author lei.you
 */
// 微服务路径
// let apiurl = 'api/v1/otd/mer/service-aggregation';
function apiurl(url) {
	return 'api/v1/otd/mer/service-aggregation' + url
}
export default {
	/*分享*/
	creditShare: apiurl('/credit/share'),

	/*我要卖车api*/
	getMyVehicles: 'v1/in/repurchase-order/vehicles',
	getC2cVehicles: 'api/v1/commodity/c2c/home',

	/* 车商城重构 */
	queryVehicles: 'api/v1/commodity/list',
	queryVehicleDetail: 'api/v1/commodity',
	collectCar: 'api/v1/commodity/favorite',
	cancelCollectCar: 'api/v1/commodity/favorite/cancel',
	collectList: 'api/v1/commodity/favorite/list',
	/*二手车订单重构*/
	createOrder: 'v1/in/order/create',
	getDeliveryCenters: 'v1/in/order/delivery-centers',
	getOrderTradeNo: 'v1/in/order/trade-no',
	getOrderDetail: 'v1/in/order',
	getOfficialCenter: 'api/v1/commodity/location-citys',
	cancelOrder: 'v1/in/order/cancel',
	getCancelReasons: 'v1/in/order/cancel-reasons',
	queryVehicleSnapshot: 'v1/in/order',
	//证件类型枚举
	getCardType: 'v1/in/order/id-type',
	//获取省份
	registerCities: 'v1/in/order/register-citys',
	//获取定金
	getDepositAmount: 'v1/in/order/deposit-amount',
	//查看车主任务
	getOrderTask: 'v1/in/order/tasks',
	//编辑车辆所有人信息
	editOwnerInfo: 'v1/in/order/owner/edit',
	//查询车辆所有人信息
	getOwnerInfo: 'v1/in/order',
	//查询购车协议
	viewPurchaseAgreement: 'v1/in/order/purchase-agreement',
	//定位获取所属城市
	getLocationWithCity: '/v1/in/order/query-city-with-location',
	//查询支付状态
	queryTradeStatus: '/v1/in/order/query-trade-status',
	//查询协议列表
	queryOrderProtocols: '/v1/in/order/protocols',
	// 运营配置信息
	commonConfig: 'api/v1/web/page/common/config',
	// 商品列表筛选条件
	filterConditionConfig: 'api/v1/common/config',
	// 检验商品定金支付状态
	checkPayStatus: '/v1/in/order/check-pay-status',
	//删除购车订单
	deleteOrder: '/v1/in/order/delete',
	// tyr预览
	previewContract: 'api/v1/tyr/doc-esign/signingDesk/contract/html/preview',
	// 推荐金融产品
	// https://apidoc.nioint.com/project/5886/interface/api/1677022
	getRecommendProduct: '/v1/in/finance-calculator/products/recommend',
	// 自定义金融产品
	// https://apidoc.nioint.com/project/5886/interface/api/1677026
	getCustomProducts: '/v1/in/finance-calculator/products/customize',
	// 月供计算
	// https://apidoc.nioint.com/project/5886/interface/api/1677029
	monthlyPaymentCalculation: '/v1/in/finance-calculator/loan-detail',
	// 创建二手车金融留资
	// https://apidoc.nioint.com/project/5886/interface/api/1676609
	createLead: '/v1/in/used-car/lead/create'
}
